import docFileIcon from '@/assets/icons/docFileTypeIcon.svg';
import pdfFileIcon from '@/assets/icons/pdfFileTypeIcon.svg';
import xlsFileIcon from '@/assets/icons/xlsFileTypeIcon.svg';

/**
 * Returns the appropriate file icon based on the file extension
 * @param fileName - The name of the file (with or without path)
 * @returns The path to the icon SVG file
 */
export function getFileIcon(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'pdf':
      return pdfFileIcon;
    case 'doc':
    case 'docx':
      return docFileIcon;
    case 'xls':
    case 'xlsx':
      return xlsFileIcon;
    default:
      return docFileIcon;
  }
}
